/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationForThreatsAzure extends models.GovernanceConfigurationBaseForThreats {
    constructor() {
        super();
        this.setDiscriminator("GovernanceConfigurationForThreatsAzure");
    }

    getFixupPrototypeFunction() { return GovernanceConfigurationForThreatsAzure.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationForThreatsAzure>): GovernanceConfigurationForThreatsAzure {
        let obj = Object.assign(new GovernanceConfigurationForThreatsAzure(), model);
        GovernanceConfigurationForThreatsAzure.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationForThreatsAzure>): GovernanceConfigurationForThreatsAzure {
        if (!model) return null;
        return GovernanceConfigurationForThreatsAzure.newInstance(<GovernanceConfigurationForThreatsAzure> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationForThreatsAzure) {
        if (!obj) return;

        models.GovernanceConfigurationForThreatsAzure.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationForThreatsAzure): boolean {
        if (models.GovernanceConfigurationBaseForThreats.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationForThreatsAzure.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource Group Name
     */
    resource_group: string;

    /**
     * Action Group
     */
    action_group: string;

}
